import React from 'react';
import { Col, Row } from 'antd';
import {
  CommentOutlined,
  LikeOutlined,
  SendOutlined,
  WarningOutlined,
} from '@ant-design/icons';
import Wrapper from './style';
import { PrintDateShort } from '../../utils/timeParser';
import { Tooltip } from '..';

const postMediaType = [
  {
    type: 'mobile_status_update',
    label: 'Status',
  },
  {
    type: 'added_photos',
    label: 'Photo',
  },
  {
    type: 'added_video',
    label: 'Video',
  },
  {
    type: 'IMAGE',
    label: 'Photo',
  },
  {
    type: 'CAROUSEL_ALBUM',
    label: 'Carousel',
  },
];

const Index = (props) => {
  const {
    dataSource,
    borderColor,
    className,
    withHover,
    withFooter,
    disabled = false,
    disabledText = 'disabled',
  } = props;

  const onGetDate = () => {
    const date = dataSource?.created_time;
    if (!date) return '';
    return PrintDateShort(date);
  };

  const onGetTypeLabel = () => {
    const selected = postMediaType?.find((item) => {
      return item?.type === dataSource?.desc;
    });
    return selected?.label || 'Status';
  };

  return (
    <Wrapper
      border_color={borderColor}
      className={className}
      with_hover={withHover}
      disabled={disabled}
    >
      <Row gutter={12}>
        <Col>
          <div className="component_post_image">
            <img src={dataSource?.image} alt="" />
          </div>
        </Col>
        <Col flex="1">
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <Row gutter={[4, 4]}>
                <Col span={24}>
                  <Row justify="space-between" wrap={false}>
                    <Col className="font-caption black1">
                      {onGetTypeLabel()}
                      &nbsp;
                      {dataSource?.id}
                    </Col>
                    <Col className="font-caption black1">{onGetDate()}</Col>
                  </Row>
                </Col>
                <Col span={24} className="font-caption black1">
                  {dataSource?.name}
                </Col>
              </Row>
            </Col>
            {withFooter && (
              <Col span={24}>
                <Row gutter={40}>
                  <Col>
                    <Row gutter={4} align="middle">
                      <Col className="font-subtitle1 black3">
                        <LikeOutlined />
                      </Col>
                      <Col className="font-caption black1">
                        {dataSource?.likes}
                      </Col>
                    </Row>
                  </Col>
                  <Col>
                    <Row gutter={4} align="middle">
                      <Col className="font-subtitle1 black3">
                        <CommentOutlined />
                      </Col>
                      <Col className="font-caption black1">
                        {dataSource?.comments}
                      </Col>
                    </Row>
                  </Col>
                  <Col>
                    <Row gutter={4} align="middle">
                      <Col className="font-subtitle1 black3">
                        <SendOutlined />
                      </Col>
                      <Col className="font-caption black1">
                        {dataSource?.sends}
                      </Col>
                    </Row>
                  </Col>
                  {disabled && (
                    <Col style={{ marginLeft: 'auto' }}>
                      <Tooltip placement="top" title={disabledText}>
                        <WarningOutlined className="font-subtitle2 orange1" />
                      </Tooltip>
                    </Col>
                  )}
                </Row>
              </Col>
            )}
          </Row>
        </Col>
      </Row>
    </Wrapper>
  );
};

export default Index;
